module.exports = __webpack_public_path__ + "static/blog-08-9f17c5d04387d8ff4d8a156efd720c49.jpg";